import {ReactionSource} from '@/domain/models/Reaction';
import {User} from '@/domain/models/User';

export enum ProfileModal {
  EditProfile = 'editProfile',
  Prompts = 'prompts',
  Languages = 'languages',
  Ethnicities = 'ethnicities',
  Nationalities = 'nationalities',
  Interests = 'interests',
}

export enum FiltersModalView {
  main = 'main',
  languages = 'languages',
  ethnicities = 'ethnicities',
  nationalities = 'nationalities',
  interests = 'interests',
  goals = 'goals',
  locations = 'locations',
  countries = 'countries',
}

export type UserModal = {
  user: User;
  source: ReactionSource;
};

type SIGN_UP_AB_TESTS = {
  web_land_e1: 'Test first AB test on the landing page';
};

type USER_AB_TESTS = never;

export type AVAILABLE_AB_TESTS = keyof SIGN_UP_AB_TESTS | USER_AB_TESTS;
